import React, { useContext, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import parse, { DOMNode } from 'html-react-parser';
import { Container, IconButton, Link, Stack, Typography } from '@mui/material';
import { Download } from '@mui/icons-material';

import { translate as t } from 'hooks/useTranslations';
import useIssuedManual from 'views/App/Portal/Policy/IssuedManuals/_data_sources/useIssuedManual';
import { IssuedManualsContext } from '../context';
import PolicyContentHelper from 'views/App/Portal/Policy/_helpers/policyContentHelper';
import TakeoverLayout from '_lex/_layouts/TakeoverLayout';
import ExportModal from '../_components/ExportModal';
import PolicyHeaders from '../_components/PolicyHeaders';
import { AppContext } from 'views/App/context';

const IssuedManualsPreface: React.FC = () => {
  const { id, prefaceId } = useParams();
  const { isFeatureEnabled } = useContext(AppContext);
  const manualQuery = useIssuedManual(id);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const preface = useMemo(() => {
    if (manualQuery.data && manualQuery.data.prefaces) {
      return manualQuery.data.prefaces.find((x) => x.id === prefaceId);
    }
  }, [prefaceId, manualQuery.data]);

  return (
    <TakeoverLayout
      backUrl={`../${id}`}
      pageTitle={[t('policy.issuedManuals.preface'), preface?.title].join(': ')}
      headerProps={{
        title: [t('policy.issuedManuals.preface'), preface?.title].join(': '),
        breadcrumbItems: [
          <Link
            key='b1'
            href='..'
          >
            {t('policy.issuedManuals.title')}
          </Link>,
          <Link
            key='b2'
            href={`../${id}`}
          >
            {manualQuery.data?.name}
          </Link>,
          <Typography key='b3'>{[t('policy.issuedManuals.preface'), preface?.title].join(': ')}</Typography>,
        ],
        actions: (
          <Stack
            direction='row'
            spacing={4}
          >
            <IconButton onClick={() => setExportModalOpen(true)}>
              <Download />
            </IconButton>
          </Stack>
        ),
      }}
    >
      {preface && preface.content && (
        <Container maxWidth='lg'>
          <Stack spacing={3}>
            {isFeatureEnabled('policy-headers') && preface.headers && preface.headers.length > 0 && (
              <PolicyHeaders
                preface={preface}
                translationPrefix='issuedManuals'
                manualId={id}
              />
            )}
            {parse(preface.content || '', {
              replace(node: DOMNode, ind: number) {
                return PolicyContentHelper.handleContent(node, ind);
              },
            })}
          </Stack>
        </Container>
      )}
      {preface && (
        <ExportModal
          open={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          exportType='content'
          manualId={id!}
          contentId={prefaceId!}
          contentType='PREFACE'
          contentTitle={preface.title}
        />
      )}
    </TakeoverLayout>
  );
};

export default IssuedManualsPreface;
